import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { hideDialog, showDialog } from "../../appRedux/actions/common";
import { deleteFaqs } from "../../appRedux/actions/faqs";

//
const BodyView = ({ info, type }) => {
  const dispatch = useDispatch();
  const { queryInfo } = useSelector((state) => ({
    queryInfo: state.faqs.queryInfo,
  }));

  return (
    <Fragment>
      {/* <p>Are you sure want to delete?</p> */}
      <div className="form-header">
        <h3>
          {info.status === "inactive" ? "Activate" : "Remove"}{" "}
          {type === "faq" ? " Faq" : " PrivacyPolicy"}
        </h3>
        <p>
          Are you sure want to {info.status === "inactive" ? "activate" : "remove"} this{" "}
          {type === "faq" ? " Faq?" : " PrivacyPolicy?"}
        </p>
      </div>
      <div className="modal-btn delete-action">
        <div className="row">
          <div className="col-6">
            <button
              onClick={() => dispatch(hideDialog())}
              className="btn btn-primary continue-btn"
              style={{ width: "100%" }}
            >
              Disagree
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={() => {
                dispatch(hideDialog());
                // navigate(linkTo, { replace: true });
                dispatch(
                  deleteFaqs({
                    faqId: info._id,
                    queryInfo,
                  })
                );
              }}
              className="btn btn-primary cancel-btn"
              style={{ width: "100%" }}
            >
              Agree
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

function DeleteModal({ info, type }) {
  // const { info } = props;
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));
  useEffect(() => {
    if (!dialog) {
      setOpen(dialog);
    }
  }, [dialog]);
  return (
    <Fragment>
      <button
        className="dropdown-item"
        onClick={() => {
          setOpen(true);
          dispatch(showDialog({ title: "", hideHeader: true }));
        }}
        key={"delete_faq"}
      >
        <i className="fa fa-trash m-r-5" /> Remove
      </button>
      {open && <DialogModal bodyView={<BodyView info={info} type={type} />}></DialogModal>}
    </Fragment>
  );
}

export default DeleteModal;
